import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { QP_VALUE } from 'src/app/constants/queryParams';
import { useQueryParams } from 'src/app/views/hooks/useQueryParams';
import { useQuestionnaire } from 'src/app/views/hooks/useQuestionnaire';
import type AppState from 'src/types/appState';

export const useCreateJob = () => {
  const {
    advertiserId,
    isDataCleanupComplete,
    questionnaireUrl,
    seekAdvertiserId,
  } = useSelector(
    (state: AppState) => ({
      advertiserId: state.session.advertiserId,
      isDataCleanupComplete: state.app.isDataCleanupComplete,
      seekAdvertiserId: state.session.seekAdvertiserId,
      questionnaireUrl: state.formData.questionnaireUrl,
    }),
    shallowEqual,
  );
  const setQuestionnaire = useQuestionnaire();
  const { getReferrerParam } = useQueryParams();

  useEffect(() => {
    const referrerParam = getReferrerParam();
    if (
      (!referrerParam || referrerParam === QP_VALUE.CREATE_JOB) &&
      isDataCleanupComplete &&
      advertiserId &&
      seekAdvertiserId &&
      !questionnaireUrl
    ) {
      setQuestionnaire();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advertiserId, isDataCleanupComplete, questionnaireUrl, seekAdvertiserId]);
};
